// extracted by mini-css-extract-plugin
export default {"container":"list_container__uDNsj","table":"list_table__ZqZUX","noData":"list_noData__IcclY"};